/** All timestamps are stored as ISO-8601 UTC strings (e.g. 2026-10-19T08:30:00.000Z). */
export type IsoDateTime = string;

export const MINUTE_MS = 60_000;
export const HOUR_MS = 60 * MINUTE_MS;
export const DAY_MS = 24 * HOUR_MS;

export function toIso(date: Date | number): IsoDateTime {
  return new Date(date).toISOString();
}

export function nowIso(): IsoDateTime {
  return new Date().toISOString();
}

/** Local calendar day key (YYYY-MM-DD) used to group practice by day. */
export function localDayKey(date: Date | number | string): string {
  const d = new Date(date);
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${m}-${day}`;
}

/** Monday 00:00 (local time) of the week containing `date`. */
export function startOfWeek(date: Date | number | string): Date {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  const offset = (d.getDay() + 6) % 7; // Monday = 0
  d.setDate(d.getDate() - offset);
  return d;
}

export function daysBetween(from: Date | number | string, to: Date | number | string): number {
  return Math.floor((new Date(to).getTime() - new Date(from).getTime()) / DAY_MS);
}
